import React from 'react';
import ReactDOM from 'react-dom/client';
import vkBridge from '@vkontakte/vk-bridge';
import App from './App';
import { isVKEnvironment } from './api/vk';
import './styles/global.css';

vkBridge.send('VKWebAppInit').catch(() => {});
if (isVKEnvironment()) {
  document.documentElement.classList.add('is-vk');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
